import { Injectable } from '@angular/core';
import { EntityType } from '@app/shared/enums/entity-type.enum';
import { ApiService } from './api.service';

@Injectable()
export class EmpresasEnvioService extends ApiService {
  entityType = EntityType.EMPRESA_ENVIO;
  url = 'api/empresas-de-envio/';
}
